import { render, staticRenderFns } from "./BindIdCard.vue?vue&type=template&id=6dacf14a&scoped=true&"
import script from "./BindIdCard.vue?vue&type=script&lang=js&"
export * from "./BindIdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dacf14a",
  null
  
)

export default component.exports